import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { QuantityBadge } from '@components/common/QuantityBadge'
import { StatusTag } from '@components/common/StatusTag'

import * as S from './styled'
import type { CollectionListItemProps } from './types'

export const CollectionListItem = ({
  name,
  quantity,
  photoUrl,
  status,
  timeFrame,
}: CollectionListItemProps) => {
  return (
    <S.Container>
      <S.Photo>
        <PhotoThumbnail url={photoUrl} size="extraLarge" />
        {quantity > 0 && <QuantityBadge quantity={quantity} />}
      </S.Photo>
      <S.Details>
        <div>{name}</div>
        {status && <StatusTag status={status} timeFrame={timeFrame} />}
      </S.Details>
    </S.Container>
  )
}
